import ExamList from '@/components/ExamList'
// import Maintenance from '@/components/Maintenance'

export default [
  // {
  //   path: '/about/',
  //   component: require('./pages/about.vue')
  // },
  // {
  //     path: '/form/',
  //     component: require('./pages/form.vue')
  // },
  {
    path: '/patient-exam-list/:patientId',
    component: ExamList
  }/* ,
  {
    path: '/maintenance/',
    component: Maintenance
  } */

]



// WEBPACK FOOTER //
// ./src/routerf7/index.js